
import StyleProvider from './StyleProvider.vue';
import TheApp from './TheApp.vue';
import Vue, { PropType } from 'vue';
import PortalVue from 'portal-vue';
import { mapActions, mapState, PiniaVuePlugin } from 'pinia';
import { useStore as useLangStore } from '@/stores/v2/lang';
import { useStore as useAuthStore } from '@/stores/v2/auth';
import i18n from '@/i18n';
import { pinia } from '@/pinia';
import { SupportedLangCodes } from '@/constants/languageCodes';
import { ProductPrintPositionAddModel } from '@/typings';
import { LogoOnlyArtwork } from '../import-wizard/typings';
import isValidLanguageValidator from '@/validators/langLocaleValidator';
import { priceDetails, pdpChoices } from '@/setters';
import VModal from 'vue-js-modal';
import { CreatePersonalizationFormWrapper } from '../import-wizard/typings/common/createPersonalization';

Vue.use(PiniaVuePlugin);
Vue.use(PortalVue, {
  portalName: 'w2p-portal',
  portalTargetName: 'w2p-portal-target',
});

Vue.use(VModal, {
  dynamic: true,
  injectModalsContainer: true,
});

export default Vue.extend({
  name: 'W2pImportWizardV2',
  components: {
    StyleProvider,
    TheApp,
  },
  props: {
    languageCode: {
      type: String as PropType<SupportedLangCodes>,
      required: false,
      default: 'none',
      validator: isValidLanguageValidator,
    },
    personalizationId: {
      type: String,
      required: false,
      default() {
        return '';
      },
    },
    context: {
      type: String,
      required: false,
      default: '',
    },
    personalizationJson: {
      type: Object as PropType<CreatePersonalizationFormWrapper>,
      required: false,
      default: () => {
        return {} as CreatePersonalizationFormWrapper;
      },
    },
    productDescription: {
      type: String,
      required: false,
      default() {
        return '';
      },
    },
    customTitle: {
      type: String,
      required: false,
      default() {
        return '';
      },
    },
    priceDetails,
    pdpChoices,
    sapCustomerId: {
      type: String,
      required: true,
    },
    endCustomerId: {
      type: String,
      required: false,
    },
    tok: {
      type: String,
      required: true,
    },
    isDirectApproval: {
      type: Boolean,
      required: false,
      default: false,
    },
    isCommunicationSentToCC: {
      type: Boolean,
      required: false,
      default: false,
    },
    notifyCustomerOnFirstProof: {
      type: Boolean,
      required: false,
      default: false,
    },
    isFirstTimeOpened: {
      type: Boolean,
      required: false,
      default: false,
    },
    isConceptDisabled: {
      type: Boolean,
      required: false,
      default: false,
    },
    isOrderDisabled: {
      type: Boolean,
      required: false,
      default: false,
    },
    printPositions: {
      type: [] as PropType<ProductPrintPositionAddModel[]>,
      required: false,
      default() {
        return [];
      },
    },
    customerCompanyLogoUrl: {
      type: String,
      required: false,
      default: '',
    },
    logoOnlyArtwork: {
      type: [] as PropType<LogoOnlyArtwork[]>,
      required: false,
      default: () => {
        return [];
      },
    },
    version: {
      type: String,
      required: false,
      default: 'V2',
    },
    sapCustomerEmail: {
      type: String,
      required: false,
      default: '',
    },
    customerCareEmail: {
      type: String,
      required: false,
      default: '',
    },
    region: {
      type: String,
      required: false,
      default: '',
    },
    userLoginOptions: {
      type: Object as PropType<{ data: string; iv: string }>,
      required: false,
      default: () => {
        return { data: '', iv: '' };
      },
    },
  },

  computed: {
    ...mapState(useLangStore, ['languageInUse']),
    ...mapState(useAuthStore, ['isTokValid']),
  },

  watch: {
    isTokValid(newValue) {
      if (!newValue) {
        this.$emit('token-invalid-or-expired');
      }
    },

    async tok(newValue) {
      if (newValue !== '') {
        this.setTok(this.tok);
        await this.setDefaultTranslations();
      }
    },
  },

  async mounted() {
    this.setLanguageLocale(this.languageCode);
    this.setSapCustomerId(this.sapCustomerId);
    this.setEndCustomerId(this.endCustomerId);
    this.setTok(this.tok);
    console.log(
      this.sapCustomerEmail,
      this.region,
      this.sapCustomerId,
      this.endCustomerId
    );
    await this.setDefaultTranslations();

    window.callConstructPersonalizationJSON =
      this.callConstructPersonalizationJSON;
  },

  methods: {
    ...mapActions(useLangStore, [
      'setLanguageLocale',
      'setDefaultTranslations',
    ]),
    ...mapActions(useAuthStore, [
      'setSapCustomerId',
      'setEndCustomerId',
      'setTok',
    ]),

    async callConstructPersonalizationJSON() {
      // Accessing the child component method using $refs
      const childComponent = this.$refs.theAppComponent as any;
      if (
        childComponent &&
        typeof childComponent.constructPersonalizationJSON === 'function'
      ) {
        console.log('callConstructPersonalizationJSON');
        const result = await childComponent.constructPersonalizationJSON();
        return result;
      } else {
        console.log('Method callConstructPersonalizationJSON not available');
        return null;
      }
    },
  },
  i18n,
  pinia,
});
